import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=069742a2&"
import script from "./WidgetFormItem.vue?vue&type=script&lang=js&"
export * from "./WidgetFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports